<template>
  <div class="base-card">
    <slot></slot>
  </div>
</template>